import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useCompany } from "./CompanyProvider/CompanyProvider";
/** * @deprecated Use `useCurrencyLocalizer()` instead. */
export const LocalizedCurrencyText = ({ value }) => {
    const { culture } = useCompany();
    const numberFormat = new Intl.NumberFormat(culture.cultureInfo, {
        style: "currency",
        currency: culture.currency,
    });
    return _jsx(_Fragment, { children: numberFormat.format(value) });
};
